import { ChangeDetectionStrategy, Component, computed, inject, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { CartService } from '../../core/services/CartService';
import { CartStore } from '../../core/stores/CartStore';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import {
  CardCodeInputModalComponent
} from '../../../cards/modals/card-code-input-modal/card-code-input-modal.component';
import {
  FixedDiscountModalComponent
} from '../fixed-discount-modal/fixed-discount-modal.component';
import { DiscountCodeInputModalComponent } from '../discount-code-input-modal/discount-code-input-modal.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-discounts-modal',
  standalone: true,
  imports: [
    TranslatePipe,
    ModalComponent,
    CardCodeInputModalComponent,
    FixedDiscountModalComponent,
    DiscountCodeInputModalComponent
  ],
  templateUrl: './discounts-modal.component.html',
  styleUrl: './discounts-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiscountsModalComponent extends BaseModalComponent {

  @ViewChild('cardCodeInputModalComponent') cardCodeInputModalComponent: CardCodeInputModalComponent;
  @ViewChild('fixedDiscountModalComponent') fixedDiscountModalComponent: FixedDiscountModalComponent;
  @ViewChild('discountCodeInputModalComponent') discountCodeInputModalComponent: DiscountCodeInputModalComponent;

  public employeeCardCode: string;

  private readonly _cartService = inject(CartService);
  private readonly _cartStore = inject(CartStore);

  public readonly isDiscountCodeActionDisabled = computed(() => {
    const cart = this._cartStore.cart();

    return !cart || cart.isRefundTransaction || cart.items.length === 0 || !!cart.discount;
  });

  public override open(val?: null): void {
    this.employeeCardCode = null;
    super.open(val);
  }

  public applyEmployeePricesToCart(btn?: HTMLButtonElement): void {
    this.employeeCardCode
      ? this.cardCodeInputModalComponent.isLoading.set(true)
      : btn.classList.add('disabled');

    this._cartService.applyEmployeePricesToCart(this.employeeCardCode)
      .pipe(
        finalize(() => {
          this.employeeCardCode
            ? this.cardCodeInputModalComponent.isLoading.set(false)
            : btn.classList.remove('disabled');
        }),
      )
      .subscribe({
        next: () => {
          if (this.employeeCardCode) {
            this.cardCodeInputModalComponent.close();
          }

          this.close();
        },
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`apply-employee-prices-to-cart/notifications/${error.message}.Message`)
          );
        }
      });
  }

  public applyFixedDiscountToCart(btn?: HTMLButtonElement): void {
    const discountConfig = this.terminalsStore.fixedDiscountPercentage();
    
    if (!discountConfig) {
      return;
    }

    if (discountConfig.min === discountConfig.max) {
      const discountPercentage = discountConfig.min;

      if (btn) {
        btn.classList.add('disabled');
      }

      this._cartService.applyFixedDiscountToCart(discountPercentage)
        .pipe(
          finalize(() => {
            if (btn) {
              btn.classList.remove('disabled');
            }
          }),
        )
        .subscribe({
          next: () => {
            this.close();
          },
          error: ({ error }: ApiErrorResponse) => {
            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`apply-fixed-discount/notifications/${error.message}.Message`)
            );
          }
        });
    } else {
      this.fixedDiscountModalComponent.open({
        mode: 'normal',
        range: {
          min: discountConfig.min,
          max: discountConfig.max
        }
      });
    }
  }
}
